import { useMemo, useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/** Tendina di selezione agenzie: spunta per includere, pulsante SOLO per isolarne una. */
export const SelettoreAgenzie = ({ agenzie = [], escluse = [], onChange, testId,
  etichetta = "Agenzia" }) => {
  const [cerca, setCerca] = useState("");
  const nomi = useMemo(() => agenzie.map((a) => a.agenzia), [agenzie]);
  const incluse = nomi.filter((n) => !escluse.includes(n));
  const visibili = agenzie.filter((a) =>
    a.agenzia.toLowerCase().includes(cerca.trim().toLowerCase()));
  const tutte = escluse.length === 0;

  const elenco = (nomi_) => (nomi_.length === 1 ? nomi_[0]
    : `${nomi_.slice(0, -1).join(", ")} e ${nomi_[nomi_.length - 1]}`);
  const riassunto = tutte ? "Tutte le agenzie"
    : incluse.length === 0 ? "Nessuna agenzia"
      : incluse.length <= 3
        ? `${incluse.length}/${nomi.length} (solo ${elenco(incluse)})`
        : `${incluse.length}/${nomi.length} (no ${elenco(escluse)})`;

  const alterna = (nome) => onChange(escluse.includes(nome)
    ? escluse.filter((x) => x !== nome)
    : [...escluse, nome]);

  return (
    <div>
      <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">
        {etichetta}
      </label>
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId} title={riassunto}
            className="w-full flex items-center gap-2 rounded-md border border-slate-200 bg-white
              px-3 py-2 text-sm text-left transition-colors duration-200
              hover:border-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0018A8]/30">
            <span className={`flex-1 truncate ${tutte ? "text-slate-500" : "text-slate-900 font-medium"}`}>
              {riassunto}
            </span>
            <ChevronDown size={14} className="text-slate-400 shrink-0" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" sideOffset={6}
          className="w-72 p-0 overflow-hidden !bg-white !opacity-100 rounded-lg border
            border-slate-200 shadow-[0_20px_45px_-12px_rgba(15,23,42,0.35)] z-50">
          <div className="flex items-center gap-2 px-3 py-2.5 bg-slate-100 border-b border-slate-200">
            <button type="button" data-testid={`${testId}-tutte`}
              onClick={() => onChange([])}
              className={`h-4 w-4 rounded border flex items-center justify-center transition-colors
                duration-200 ${tutte ? "bg-[#14284B] border-[#14284B]" : "bg-white border-slate-300"}`}>
              {tutte ? <Check size={11} className="text-white" /> : null}
            </button>
            <span className="text-xs font-bold uppercase tracking-[0.12em] text-slate-700">
              {etichetta}
            </span>
            {!tutte ? (
              <button type="button" data-testid={`${testId}-azzera`} onClick={() => onChange([])}
                className="ml-auto text-[10px] uppercase tracking-[0.12em] font-semibold text-slate-500
                  hover:text-[#C8102E] transition-colors duration-200">Tutte</button>
            ) : null}
          </div>
          <div className="px-3 py-2 border-b border-slate-100">
            <input value={cerca} onChange={(e) => setCerca(e.target.value)}
              data-testid={`${testId}-cerca`} placeholder="Digita per effettuare la ricerca"
              className="w-full text-xs px-2 py-1.5 rounded border border-slate-200
                focus:outline-none focus:ring-2 focus:ring-[#0018A8]/30" />
          </div>
          <div className="max-h-72 overflow-y-auto py-1">
            {visibili.map((a) => {
              const dentro = !escluse.includes(a.agenzia);
              return (
                <div key={a.slug}
                  className="group flex items-center gap-2 px-3 py-1.5 hover:bg-slate-50
                    transition-colors duration-150">
                  <button type="button" data-testid={`${testId}-voce-${a.slug}`}
                    onClick={() => alterna(a.agenzia)}
                    className="flex items-center gap-2 flex-1 text-left">
                    <span className={`h-4 w-4 rounded border flex items-center justify-center shrink-0
                      transition-colors duration-200
                      ${dentro ? "bg-[#14284B] border-[#14284B]" : "bg-white border-slate-300"}`}>
                      {dentro ? <Check size={11} className="text-white" /> : null}
                    </span>
                    <span className={`text-xs truncate ${dentro ? "text-slate-800" : "text-slate-400"}`}>
                      {a.agenzia}
                    </span>
                  </button>
                  <button type="button" data-testid={`${testId}-solo-${a.slug}`}
                    onClick={() => onChange(nomi.filter((n) => n !== a.agenzia))}
                    className="opacity-0 group-hover:opacity-100 rounded bg-slate-200 px-2 py-0.5
                      text-[10px] font-bold uppercase tracking-wider text-slate-600
                      hover:bg-slate-300 transition-all duration-200">
                    Solo
                  </button>
                </div>
              );
            })}
            {!visibili.length ? (
              <div className="px-3 py-4 text-xs text-slate-400">Nessuna agenzia trovata</div>
            ) : null}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
